<template>
  <v-main>
    <v-card class="test-description pa-3 pl-6">
      <v-row>
        <v-col cols="7" md="10" lg="10" sm="10">
          <!-- {{ test.subject.name }} - {{ test.subject.room.sections }} -->
          <h4>{{ test.subject.name }} - {{ test.subject.room.sections }}</h4>
          <h1 class="pb-0 test-name">{{ test.tname }}</h1>
          <p class="description-text">
            <b>{{ startDateTime }} - {{ endDateTime }}</b>
          </p>
          <p class="description-text">
            Marks:
            <b v-if="test.marks">{{ test.marks }}</b>
            <b v-else>0</b>
          </p>
          <p class="description-text">{{ test.description }}</p>
        </v-col>

        <v-col cols="5" md="2" lg="2" sm="2">
          <h1 class="marks">{{ test.questions_count }}</h1>
          <h3 class="mtext">Questions</h3>
        </v-col>
      </v-row>
      <div class="text-right" v-if="currentUser.is_student">
        <span class="test-intructions">Test Intructions</span>
        <v-btn icon @click="instructionsShow = !instructionsShow">
          <v-icon>{{ instructionsShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>

      <v-expand-transition>
        <div v-show="instructionsShow">
          <v-divider></v-divider>
          <v-card-text>
            <ul>
              <li>All acitvities including minimising this window, switching tabs, resiszing the browser are recorded and marked as cheating.</li>
              <li>Test will be auto submitted on timeout, however you are advised to submit it before hand.</li>
            </ul>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </v-main>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "TestDescription",
  props: ["test"],
  data() {
    return {
      instructionsShow: true,
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    startDateTime: function () {
      var d = new Date(this.test.start_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
    endDateTime: function () {
      var d = new Date(this.test.end_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
  },
};
</script>

<style scoped>
.container {
  min-height: auto;
}
.test-description {
  padding: 10px;
  padding-left: 30px;
  border-top: 5px solid #009688;
  border-radius: 20px;
}
.description-text {
  margin-top: 10px;
}
h1.test-name {
  border-bottom: 1px solid #009688;
}
.marks {
  text-align: center;
  font-size: 40px;
}
.mtext {
  text-align: center;
}
.text-right {
  text-align: end;
}
.test-intructions {
  color: #009688;
}
</style>
